module.exports = "/templates/bds/public/images/bbb536773a6bf66947ef093b9c52a1e7.png";